module.exports = __webpack_public_path__ + "static/media/time_evening.ed0544ec.svg";